export default __webpack_public_path__ + "static/media/summary.8e5a0419.svg";